export enum AppThemeName {
  DEFAULT = 'DEFAULT',
  PROD = 'PROD',
  STG = 'STG',
  DEV = 'DEV',
}

export interface AppTheme {
  sideMenu: {
    backgroundColor: string;
  };
}

const DEFAULT_APP_THEME: AppTheme = {
  sideMenu: {
    backgroundColor: 'var(--greenprimary)',
  },
};

export const appThemes: { [key in AppThemeName]: AppTheme } = {
  DEFAULT: DEFAULT_APP_THEME,
  PROD: DEFAULT_APP_THEME,
  STG: {
    sideMenu: {
      backgroundColor: 'var(--blueprimary)',
    },
  },
  /*DEV: {
    sideMenu: {
      backgroundColor: 'var(--textsecondary)',
    },
  },*/
  DEV: DEFAULT_APP_THEME,
};

export const isAppThemeName = (
  name: string | undefined,
): name is AppThemeName => {
  return !!(name && Object.keys(AppThemeName).includes(name));
};
